/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TaskEduContentInterface } from '../../+models';
import { CalculateTaskEduContentResponseInterface, UpdateTaskEduContentResultInterface } from '../../tasks';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class TaskEduContentApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'TaskEduContents');
  }

  find(params?: Record<string, any>): Observable<TaskEduContentInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<TaskEduContentInterface[]>(path, httpParams);
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<void>(path).pipe(map(() => true));
  }

  destroyTaskEduContents(taskEduContentIds: number[]): Observable<UpdateTaskEduContentResultInterface> {
    return this.post('destroy-task-edu-contents', undefined, taskEduContentIds);
  }

  updateTaskEduContents(
    taskEduContents: Partial<TaskEduContentInterface>[]
  ): Observable<UpdateTaskEduContentResultInterface> {
    return this.patch('update-task-edu-contents', undefined, taskEduContents);
  }

  createTaskEduContents(
    taskEduContents: Partial<TaskEduContentInterface>[]
  ): Observable<UpdateTaskEduContentResultInterface> {
    const path = 'create-task-edu-contents';
    return this.post(path, undefined, { taskEduContents });
  }

  calculateTaskEduContentsForTask(taskId: number): Observable<CalculateTaskEduContentResponseInterface> {
    const path = `${taskId}/calculate-task-edu-contents`;
    return this.post(path);
  }
}
